export const routes = {
  home: {
    index: "/home",
    requiresSession: true,
  },
  onboarding: {
    index: "/onboarding",
    requiresSession: true,
  },
  inPerson: {
    index: "/in-person",
    requiresSession: true,
  },
  inPersonMobile: {
    index: "/in-person-mobile",
    worklet: "/in-person-mobile-worklet",
    requiresSession: true,
  },
  videoMeeting: {
    index: "/video-meeting",
  },
  audioTranscription: {
    index: "/audio-transcription",
  },
  conversations: {
    index: "/conversations",
    details: (conversationId: string) => `/conversations/${conversationId}`,
    requiresSession: true,
  },
  clients: {
    index: "/clients",
    details: (clientId: string) => `/clients/${clientId}`,
    requiresSession: true,
  },
  insights: {
    index: "/insights",
    requiresSession: true,
  },
  formFill: {
    index: "/form-fill",
    new: "/form-fill/new",
    details: (id: string) => `/form-fill/${id}`,
    requiresSession: true,
  },
  deliverables: {
    index: "/deliverables",
    new: "/deliverables/new",
    details: (id: string) => `/deliverables/${id}`,
    requiresSession: true,
  },
  settings: {
    index: "/settings",
    integrations: "/settings/integrations",
    account: "/settings/account",
    email: "/settings/email",
    billing: "/settings/billing",
    meeting: "/settings/meeting",
    organization: "/settings/organization",
    users: "/settings/users",
    phone: "/settings/phone",
    permissions: "/settings/permissions",
    customization: "/settings/customization",
    dataRetention: "/settings/data-retention",
    requiresSession: true,
  },
  meetings: {
    index: "/meetings",
    details: (id: string) => `/meetings/${id}`,
    requiresSession: true,
  },
  meetingPrep: {
    index: "/meeting-prep",
    details: (id: string) => `/meeting-prep/${id}`,
  },
  organization: {
    index: "/organization",
    details: (id: string) => `/organization/${id}`,
    requiresSession: true,
  },
  recovery: {
    index: "/recovery",
    requiresSession: true,
  },
  login: {
    index: "/login",
    requiresSession: true,
  },
  auth: {
    authenticate: "/authenticate",
    forgotPassword: "/forgot-password",
    resetPassword: "/reset-password",
    authorize: "/authorize",
    false: true,
  },
  checkout: {
    index: "/checkout",
    requiresSession: false,
  },
  admin: {
    index: "/admin",
    users: "/admin/users",
    billing: "/admin/billing",
    settings: "/admin/settings",
    integrations: "/admin/integrations",
    requiresSession: true,
  },
  oauth: {
    index: "/oauth",
  },
};
